// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleEmbed_container__1K7NE","body":"ArticleEmbed_body__MKWP1"};